var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.6399C11.6427 12.6413 11.2959 12.76 11.0128 12.9776C10.7296 13.1953 10.5258 13.5 10.4326 13.8448C10.3395 14.1895 10.3622 14.5554 10.4972 14.886C10.6322 15.2167 10.872 15.4939 11.1799 15.6749V17.9999H12.8399V15.6749C13.0834 15.5308 13.2856 15.3262 13.4266 15.0809C13.5677 14.8356 13.6429 14.5579 13.6449 14.2749V14.2749C13.6449 14.0594 13.6023 13.8459 13.5195 13.6469C13.4367 13.4479 13.3154 13.2672 13.1625 13.1153C13.0096 12.9633 12.8282 12.8431 12.6286 12.7615C12.4291 12.6799 12.2154 12.6386 11.9999 12.6399V12.6399Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1449 8.88501H5.84994C4.65701 8.88501 3.68994 9.85207 3.68994 11.045V19.59C3.68994 20.7829 4.65701 21.75 5.84994 21.75H18.1449C19.3379 21.75 20.3049 20.7829 20.3049 19.59V11.045C20.3049 9.85207 19.3379 8.88501 18.1449 8.88501Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67505 8.885V7.58C6.67505 6.1664 7.2366 4.81069 8.23617 3.81112C9.23574 2.81155 10.5914 2.25 12.005 2.25C13.4187 2.25 14.7744 2.81155 15.7739 3.81112C16.7735 4.81069 17.335 6.1664 17.335 7.58V8.885",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordicon);
export default __webpack_public_path__ + "static/media/passwordicon.aff8d600d5b720f6b2b2849f31f124c0.svg";
export { ForwardRef as ReactComponent };